// extracted by mini-css-extract-plugin
export default {"logo-wrapper":"Logo_logo-wrapper__wkMVG","logo":"Logo_logo__GABeq"};